import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Badge3rdParty = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M14.34 5.152 12 3 9.66 5.152 6.439 4.72l-.563 3.049L3 9.218 4.43 12 3 14.781l2.875 1.451.563 3.05 3.223-.434L12 21l2.34-2.152 3.222.433.563-3.049L21 14.782 19.57 12 21 9.219l-2.875-1.451-.563-3.05-3.223.434Z"
      fill="#4F9BDE"
      fillRule="evenodd"
    />
    <path d="m8.019 11.814 1.338-1.273 1.697 1.614 3.393-3.228 1.339 1.273-4.732 4.5-3.035-2.886Z" fill="#fff" />
  </Icon>
));

export default Badge3rdParty;
